import React from "react";
import ExportPreviewTemplate from './ExportPreviewTemplate'
import {Container} from 'react-bootstrap'
import NewWindow from 'react-new-window'

// import {useRef, useEffect} from "react";

const ExportPreview = ({cupping, name, tableName, tableDate, cuppingNum, toggleExportPreview}) => {
  
  return (
          <Container className="exportPreview" 
          // ref={node}
          >
              <NewWindow title="Catoro Preview Export (Beta)" onUnload={toggleExportPreview} >
                <ExportPreviewTemplate cupping={cupping} name={name} tableName={tableName} cuppingNum={cuppingNum} tableDate={tableDate}/>
              </NewWindow>
          </Container>
        )
  }

  export default ExportPreview